/* KTS Page Kit — util JS for pages using kts-page-kit.css
 * - count-up animation on .kts-countup elements
 * Safe to load globally; no-op if elements/APIs absent.
 */
(function(){
  'use strict';

  function boot(){
    var root = document;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---- count-up stats ----
    // Usage: <span class="kts-countup" data-target="29000" data-suffix="+" data-duration="1400">0</span>
    var counters = root.querySelectorAll('.kts-countup');
    if(!counters || !counters.length) return;

    function animateCounter(el){
      var target   = parseFloat(el.getAttribute('data-target') || el.textContent || '0');
      var suffix   = el.getAttribute('data-suffix') || '';
      var prefix   = el.getAttribute('data-prefix') || '';
      var duration = parseInt(el.getAttribute('data-duration') || '1400', 10);
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var start = performance.now();
      function step(now){
        var p = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = target * eased;
        var formatted = val.toFixed(decimals);
        if(target >= 1000) formatted = Math.floor(val).toLocaleString('en-US');
        el.textContent = prefix + formatted + suffix;
        if(p < 1) requestAnimationFrame(step);
        else el.textContent = prefix + (target >= 1000 ? target.toLocaleString('en-US') : target.toFixed(decimals)) + suffix;
      }
      requestAnimationFrame(step);
    }

    function renderFinal(el){
      var target   = parseFloat(el.getAttribute('data-target') || '0');
      var suffix   = el.getAttribute('data-suffix') || '';
      var prefix   = el.getAttribute('data-prefix') || '';
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var formatted = target >= 1000 ? target.toLocaleString('en-US') : target.toFixed(decimals);
      el.textContent = prefix + formatted + suffix;
    }

    if('IntersectionObserver' in window && !reduced){
      var cio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            animateCounter(e.target);
            cio.unobserve(e.target);
          }
        });
      }, { threshold: .35 });

      counters.forEach(function(el){
        el.textContent = (el.getAttribute('data-prefix') || '') + '0' + (el.getAttribute('data-suffix') || '');
        cio.observe(el);
      });
    } else {
      // fallback: render final values without animation
      counters.forEach(renderFinal);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
